module.exports = __webpack_public_path__ + "img/banner-web-app.5ed0ca0c.jpg";